import { createFileRoute } from "@tanstack/react-router";

import { parseNewOrderSearch } from "@/features/orders";
import { NewOrderPage } from "@/features/orders/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/orders/new")({
  validateSearch: strictSearch(parseNewOrderSearch),
  component: NewOrder,
});

function NewOrder() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <NewOrderPage
      search={search}
      // Picking a client or an address is a step of the call, not a page to go back to.
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
